import { PrismicRichText } from '@prismicio/react';
import { Button } from 'remote-com-shared/components/Button';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { HubspotFormModalButton } from 'remote-com-shared/components/HubspotForm';
import { TwoStepFormModalButton } from 'remote-com-shared/components/TwoStepForm';
import { transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp, whenProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { Description, Title } from './BenefitsIntroSlice';

import { fieldHasContent } from '@/src/domains/prismic/helpers';
import HeroBackgroundImage from '@/src/views/BenefitsDirectory/assets/onboarding-bg.png';

const CTATitle = styled(Description)`
  margin-bottom: 8px;
  margin-top: 16px;
  padding: 0;
`;

const Wrapper = styled.div`
  ${fluidProp('padding-top', '64px', '120px')}
  margin-bottom: 0;
  text-align: center;

  ${whenProp(
    '$bg-image',
    css`
      ${fluidProp('padding-bottom', '64px', '120px')}
      background-image: url(${HeroBackgroundImage.src});

      ${Title} {
        color: white;
      }
      ${CTATitle} {
        color: white;
      }
    `
  )}
`;

const CtaWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  ${fluidProp('gap', '32px', '64px')}
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export function CtaSlice({ slice }) {
  const { primary, fields } = transformProperties(slice);
  const { title, backgroundImage } = primary;

  return (
    <Wrapper $bg-image={backgroundImage}>
      <ContentContainer>
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        <CtaWrapper>
          {fields.map((entry, index) => (
            <ButtonContainer key={index}>
              {fieldHasContent(entry.ctaTitle) && (
                <CTATitle>
                  <PrismicRichText field={entry.ctaTitle} />
                </CTATitle>
              )}
              <CtaButton {...{ ...entry, index }} />
            </ButtonContainer>
          ))}
        </CtaWrapper>
      </ContentContainer>
    </Wrapper>
  );
}

function CtaButton({ ctaLabel, ctaLink, formId, useTwoStepForm, index }) {
  if (formId) {
    return (
      <HubspotFormModalButton as={Button} formId={formId} formName={`benefits-directory-${index}`}>
        {ctaLabel}
      </HubspotFormModalButton>
    );
  }

  if (useTwoStepForm) {
    return <TwoStepFormModalButton as={Button}>{ctaLabel}</TwoStepFormModalButton>;
  }

  if (ctaLink) {
    return <Button href={ctaLink?.url}>{ctaLabel}</Button>;
  }

  return null;
}
